module.exports = __webpack_public_path__ + "img/top.1545ed63.png";